import { css } from "@emotion/react";
import { colorPalette } from "../../theme/colors";
import { BadgeProps } from "./Badge.types";

export const generateBadgeStyles = ({ variant }: BadgeProps) => {
  switch (variant) {
    case "primary":
      return css`
        background-color: ${colorPalette.wishlink[500]};
        color: ${colorPalette.popWhite[500]};
      `;
    default:
      return css`
        background-color: ${colorPalette.popWhite[500]};
        color: ${colorPalette.popBlack[500]};
      `;
  }
};
